import React, { useContext } from "react";
import { Link } from "gatsby";
import {
	Box,
	useTheme,
	Container,
	Grid,
	Typography,
	styled,
	Button,
} from "@mui/material";
import { SiteContext } from "gatsby-frontend/src/Site";

const FooterBlock = styled(Box)(({ theme }) => ({
	"& > *:not(:first-child)": {
		marginTop: theme.spacing(1),
		marginBottom: 0,
	},
	"& img": {
		width: "100%",
		height: "auto",
		maxWidth: 240,
	},
	"& ul": {
		listStyle: "none",
		padding: 0,
		margin: 0,
	},
}));

const LinkText = styled(Link)(({ theme, direction = "row" }) => ({
	display: direction === "row" ? "inline-block" : "block",
	alignItems: "center",
	paddingRight: theme.spacing(3),
	margin: direction === "column" ? theme.spacing(1, 0) : 0,
	// fontSize: "0.9em",
	"& .MuiListItemText-root": {
		display: "inline-block",
		verticalAlign: "middle",
	},
}));

function Footer() {
	const theme = useTheme();

	const { footerNavData, footerData, colophonText } = useContext(SiteContext);
	let submenus = footerNavData.filter(
		(nv) => typeof nv.children !== "undefined"
	);
	let links = footerNavData.filter((nv) => typeof nv.path !== "undefined");
	let cols = footerData
		? footerData.filter((d) => d.value && d.value.length > 0)
		: [];

	cols = cols.map((d, i) => ({
		id: `col-${i}`,
		content: <div dangerouslySetInnerHTML={{ __html: d.value }} />,
	}));
	if (submenus.length > 0) {
		cols = cols.concat(
			submenus.map((submenu, i) => ({
				id: `sm-${i}`,
				content: (
					<div key={`sm-${i}`}>
						{submenu.title && submenu.title !== "" && (
							<Typography
								sx={{ marginBottom: theme.spacing(1) }}
								className="subtitle"
							>
								{submenu.title}
							</Typography>
						)}
						<nav>
							{submenu.children
								.filter((c) => !!c.path)
								.map(({ title, path }) => (
									<a href={path} key={title} direction="column">
										<Typography>{title}</Typography>
									</a>
								))}
						</nav>
					</div>
				),
			}))
		);
	}

	if (
		theme?.customOptions?.customNewsletterInput &&
		theme.customOptions.customNewsletterInput.trim() !== ""
	) {
		const customTitle =
			theme?.customOptions?.customNewsletterTitle ||
			"Sign up for our newsletter";

		cols = cols.concat({
			id: "newsletter",
			content: (
				<div>
					<Box className="footer-newsletter">
						<Typography variant="h5">{customTitle}</Typography>
						<div
							dangerouslySetInnerHTML={{
								__html: theme.customOptions.customNewsletterInput,
							}}
						/>
					</Box>
				</div>
			),
		});
	}

	let total_items = cols.length;
	let width = total_items < 4 ? Math.floor(12 / total_items) : 3;
	if (cols.length === 0 && links.length === 0) {
		return <></>;
	}
	return (
		<Box
			id="footer"
			component="footer"
			sx={{
				padding: theme.spacing(6, 0, 4),
				overflow: "hidden",
				backgroundColor: theme.palette.footer.main,
				color: theme.palette.footer.contrastText,
				...(theme.palette.footer.gradient && {
					backgroundImage: theme.palette.footer.gradient,
				}),
				"& a": {
					color: theme.palette.footer.contrastText,
				},
				"& p, & .subtitle": {
					fontSize: "0.9em",
					lineHeight: 1.4,
					marginTop: 0,
				},
				"& .subtitle": {
					fontWeight: theme.typography.fontWeightBold,
				},
				"& .colophon": {
					"& p, & .subtitle": {
						fontSize: "0.8em",
					},
				},
			}}
		>
			<Container maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}>
				{cols.length > 0 && (
					<Grid container spacing={6}>
						{cols.map((c) => (
							<Grid item key={c.id} xs={12} sm={width}>
								<FooterBlock>{c.content}</FooterBlock>
							</Grid>
						))}
					</Grid>
				)}
				<Box
					component="nav"
					className="colophon"
					sx={{
						display: "block",
						paddingLeft: 0,
						width: "100%",
						marginTop: theme.spacing(4),
						paddingTop: theme.spacing(2),
						position: "relative",
						"& b": {
							width: "100%",
							display: "block",
							height: "1px",
							backgroundColor: theme.palette.footer.contrastText,
							opacity: 0.2,
							position: "absolute",
							top: 0,
							left: 0,
						},
					}}
				>
					<b></b>

					<Typography
						sx={{ display: "inline-block", marginRight: theme.spacing(3) }}
					>{`© ${new Date().getFullYear()} ${colophonText}`}</Typography>

					{links.length > 0 &&
						links.map(({ title, path }) => (
							<LinkText to={path} key={title}>
								<Typography>{title}</Typography>
							</LinkText>
						))}
				</Box>
			</Container>
		</Box>
	);
}

export default Footer;
